import React, { useState } from 'react';
import Header from '../../components/Header/Header';
import dropdown from "../../assets/Icons/dropdown.svg";
import { useForm } from 'react-hook-form';
import { CircularProgress } from '@mui/material';
import { createPlan, generateReportLink } from '../../services/PlanServices';

const CreatePlanForm = ({ formData, register, errors, id }) => {
  const codeKey = `${id}_code`;
  const monitoredKey = `${id}_monitored`;
  const typeKey = `${id}_type`;
  const repsKey = `${id}_repsCount`;
  const setsKey = `${id}_setsCount`;
  const holdKey = `${id}_holdTime`;
  return (
    <div className='flex gap-4'>
      <div className='flex flex-col gap-[5px]'>
        <label htmlFor='code' value={formData.codeKey}>Exercise Code</label>
        <input id='code' type='text' className='w-[8rem] border border-[#E1E5EB] rounded focus:outline-none px-[1rem] py-[0.5rem]' {...register(codeKey, { required: true })} />
        { errors[codeKey] && <div className='text-[red] mt-[-5px]'>required</div>}
      </div>
      <div className='flex flex-col gap-[5px]'>
        <label htmlFor='type'>Exercise Type</label>
        <select
          value={formData.typeKey}
          name=""
          id="type"
          className="w-[8rem] outline-none rounded appearance-none px-6 py-2 cursor-pointer"
          style={{
            border: "1px solid #E1E5EB",
            backgroundImage: `url(${dropdown})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right 10px center",
            backgroundSize: "20px",
            paddingRight: "30px",
          }}
          {...register(typeKey, { required: true })}
        >
          <option value="">Select Exercise Type</option>
          <option value="rep">Rep</option>
          <option value="rep-hold">Rep-Hold</option>
        </select>
        { errors[typeKey] && <div className='text-[red] mt-[-5px]'>required</div>}
      </div>
      <div className='flex flex-col gap-[5px]'>
        <label htmlFor='code'>Monitored</label>
        <select
          value={formData.monitoredKey}
          name=""
          id="type"
          className="w-[8rem] outline-none rounded appearance-none px-6 py-2 cursor-pointer"
          style={{
            border: "1px solid #E1E5EB",
            backgroundImage: `url(${dropdown})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right 10px center",
            backgroundSize: "20px",
            paddingRight: "30px",
          }}
          {...register(monitoredKey, { required: true })}
          // onChange={(e) => changeHandler("monitored", e.target.value, index)}
        >
          <option value="">Select Monitor Flag</option>
          <option value="true">True</option>
          <option value="false">False</option>
        </select>
        { errors[monitoredKey] && <div className='text-[red] mt-[-5px]'>required</div>}
      </div>
      <div className='flex flex-col gap-[5px]'>
        <label htmlFor='repsCount' value={formData.codeKey}>Reps</label>
        <input id='repsCount' type='number' className='w-[8rem] border border-[#E1E5EB] rounded focus:outline-none px-[1rem] py-[0.5rem]' {...register(repsKey, { required: true })} />
        { errors[repsKey] && <div className='text-[red] mt-[-5px]'>required</div>}
      </div>
      <div className='flex flex-col gap-[5px]'>
        <label htmlFor='repsCount' value={formData.codeKey}>Sets</label>
        <input id='repsCount' type='number' className='w-[8rem] border border-[#E1E5EB] rounded focus:outline-none px-[1rem] py-[0.5rem]' {...register(setsKey, { required: true })} />
        { errors[setsKey] && <div className='text-[red] mt-[-5px]'>required</div>}
      </div>
       <div className='flex flex-col gap-[5px]'>
        <label htmlFor='repsCount' value={formData.codeKey}>HoldTime</label>
        <input id='repsCount' type='number' className='w-[8rem] border border-[#E1E5EB] rounded focus:outline-none px-[1rem] py-[0.5rem]' {...register(holdKey, { required: formData[typeKey] === "rep-hold" })} />
        { errors[holdKey] && <div className='text-[red] mt-[-5px]'>required</div>}
      </div>
    </div>
  )
}

const GeneratePlan = () => {
  const generateId = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const generatedText = Array.from({ length: 7 }, () => characters[Math.floor(Math.random() * characters.length)]).join('');
    return generatedText;
  }

  const [ exercises, setExercises ] = useState([{ id: generateId(), code: "" , type: '' , monitored: "", repsCount: '', setsCount: '', holdTime: '' }]);
  const [ showBtns , setShowBtns ] = useState(false);
  const [ showReportBtns , setShowReportBtns ] = useState(false);
  const [ link, setLink ] = useState('');
  const [ reportLink, setReportLink ] = useState('');
  const [ showCopiedLink , setShowCopiedLink ] = useState(false);
  const [ showReportCopiedLink , setShowReportCopiedLink ] = useState(false);
  const [ showError , setShowError ] = useState(null);
  const [ showReportError , setShowReportError ] = useState(null);
  const { register, watch, handleSubmit, formState: { errors }} = useForm();
  const [ loading , setLoading ] = useState(false);
  const [ reportLoading , setReportLoading ] = useState(false);
  const [ reportLinkInput , setReportLinkInput ] = useState("");

  const addMoreExerciseHandler = () => {
    setExercises(prev => [ ...prev , { id: generateId() , code: "" , type: '' , monitored: "", repsCount: '', setsCount: '', holdTime: '' } ]);
  }

  const handleClick = () => {
    navigator.clipboard.writeText(link);
    setShowCopiedLink(true);
    setTimeout(() => setShowCopiedLink(false) , 2000);
  }

  const handleReportClick = () => {
    navigator.clipboard.writeText(reportLink);
    setShowReportCopiedLink(true);
    setTimeout(() => setShowReportCopiedLink(false) , 2000);
  }

  const formData = watch();

  const getAlignedData = (inputData) => {
    const transformedData = [];

    for (const key in inputData) {
      const id = key.split('_')[0];
      if (
        key.endsWith('_code') &&
        inputData.hasOwnProperty(`${id}_type`) &&
        inputData.hasOwnProperty(`${id}_monitored`) &&
        inputData.hasOwnProperty(`${id}_setsCount`) &&
        inputData.hasOwnProperty(`${id}_repsCount`) &&
        inputData.hasOwnProperty(`${id}_holdTime`)
      ) {
        transformedData.push(
        {
          "exercise_spry_code": inputData[key],
          "exercise_config": {
              "exercise_type": inputData[`${id}_type`],
              "sets_count": Number(inputData[`${id}_setsCount`]),
              "reps_count": Number(inputData[`${id}_repsCount`]),
              "hold_duration_in_seconds": Number(inputData[`${id}_holdTime`])
          },
          "cv_enabled": inputData[`${id}_monitored`]
      });
      }
    }
  
    return transformedData;
  };

  const onSubmit = async() => {
    setShowBtns(false);
    setShowError(null);
    setLoading(true);
    createPlan(getAlignedData(formData)).then( res => {
      if( res.code === 500 ){
        setShowError(res?.message);
        setLoading(false);
      }else if( res.code === 2000 ){
        setLink(res.data)
        setShowBtns(true);
        setLoading(false);
      }
    })
  }

  const reportSubmitHandler = (e) => {
    setShowReportError(null);
    setShowReportBtns(false);
    e.preventDefault();
    const token = reportLinkInput.split('&')[0].split('=')[1] || null
    if( token !== null ){
      setReportLoading(true);
      generateReportLink(token).then(res => {
        if(res.code === 2000){
          setReportLink(res.data);
          setReportLoading(false);
          setShowReportBtns(true);
        }else{
          setShowReportError("error");
        }
      })
    }else{
      setShowReportError("invalid link");
    }
  }

  return (
    <div className="max-w-[1440px] mx-auto pb-[4rem] bg-[#F5F9FF]">
      <Header />
      <div className="max-w-[1280px] min-h-screen mx-auto my-0">
         <h1 className='w-full my-[2rem] flex justify-center items-center text-[1.3rem]'>Generate Simple Therapy Plan</h1>
         <div>
            <form className='flex flex-col gap-6' onSubmit={handleSubmit(onSubmit)}>
              {
                exercises.map( (ele, index) => {
                  return (
                    <div className='flex gap-4' key={ele.id}>
                      <CreatePlanForm formData={formData} register={register} errors={errors} id={ele.id}  />
                      { exercises.length - index === 1 && <button className='border border-[#415280] rounded text-[#415280] px-[1rem] py-[0.5rem] h-fit self-end' onClick={() => addMoreExerciseHandler()}>Add One More Exercise</button>}
                    </div>
                  )
                })
              }
              <button className='border rounded bg-[#415280] text-[#fff] my-[1rem] px-[1rem] py-[0.5rem] w-fit' type='submit'>Create Plan { loading ? <CircularProgress size={18} /> : ""}</button>
              { showError !== null && <div className='text-[red]'>{showError}</div>}
            </form>
            { 
              showBtns && 
              <div className="flex gap-10 justify-center items-center">
                  <div className="border-[1px] rounded px-3 py-2 cursor-pointer bg-[#788cfc] text-[#fff]" onClick={() => window.open( link, '_blank') }>open link</div>
                  <div className="border-[1px] border-[#788cfc] rounded px-3 py-2 cursor-pointer bg-[#fff] text-[#788cfc]" onClick={() => handleClick()}>{ showCopiedLink ? "Copied the Link" : "Copy Link" }</div>
              </div>
            }
          </div>
          <form className='flex gap-4 w-full mt-[4rem]' onSubmit={reportSubmitHandler}>
            <div className='flex flex-col gap-[5px] w-full'>
              <label htmlFor='code' value={reportLinkInput}>Paste your link to get report link</label>
              <input id='code' type='text' className='w-full border border-[#E1E5EB] rounded focus:outline-none px-[1rem] py-[0.5rem]' onChange={(e) => setReportLinkInput(e.target.value)} />
              { showReportError && <div className='text-[red]'>{showReportError}</div>}
            </div>
            <button className='border rounded bg-[#415280] text-[#fff] px-[1rem] py-[0.5rem] self-end h-fit w-[15rem]' type='submit'>Generate Report { reportLoading ? <CircularProgress size={18} /> : ""}</button>
          </form>
          { 
            showReportBtns && 
            <div className="flex gap-10 justify-center items-center my-[2rem]">
                <div className="border-[1px] rounded px-3 py-2 cursor-pointer bg-[#788cfc] text-[#fff]" onClick={() => window.open( reportLink, '_blank') }>open Report link</div>
                <div className="border-[1px] border-[#788cfc] rounded px-3 py-2 cursor-pointer bg-[#fff] text-[#788cfc]" onClick={() => handleReportClick()}>{ showReportCopiedLink ? "Copied Report the Link" : "Copy Report Link" }</div>
            </div>
          }
      </div>
    </div>
  )
}

export default GeneratePlan
